(() => {
  const menu = document.querySelector("[data-mb-menu]");
  if (!menu) return;

  const panels = () => menu.querySelectorAll("[data-mb-panel]");
  const rootPanel = () => menu.querySelector('[data-mb-panel="root"]');

  const showPanel = (id) => {
    panels().forEach((panel) => {
      const match = panel.getAttribute("data-mb-panel") === id;
      panel.classList.toggle("is-active", match);
      if (panel.getAttribute("data-mb-panel") !== "root") {
        panel.setAttribute("aria-hidden", match ? "false" : "true");
      }
    });
    const root = rootPanel();
    if (root) {
      root.classList.toggle("is-pushed", id !== "root");
    }
    menu.classList.toggle("is-drill", id !== "root");
  };

  menu.addEventListener("click", (event) => {
    const openBtn = event.target.closest("[data-mb-open]");
    if (openBtn) {
      event.preventDefault();
      showPanel(openBtn.getAttribute("data-mb-open"));
      return;
    }

    const backBtn = event.target.closest("[data-mb-back]");
    if (backBtn) {
      event.preventDefault();
      showPanel("root");
    }
  });

  menu.addEventListener("hidden.bs.offcanvas", () => {
    showPanel("root");
  });
})();
